import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container, Header } from "semantic-ui-react";
import { Navigation } from "src/components/Navigation";
import { withAuthorization } from "../../components/Session/withAuthorization";
import AnalysesTable from "./AnalysesTable";
const AnalysesComponent = ({
  authUser,
  orgId,
  history,
  location,
  match,
  usersStatus,
}: any) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <Header as="h2" className="page-title">
        Analyses
      </Header>
      <AnalysesTable
        authUser={authUser}
        location={location}
        orgId={orgId}
        history={history}
        usersStatus={usersStatus}
      />
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const Analyses = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(AnalysesComponent));

export default Analyses;



// WEBPACK FOOTER //
// ./src/containers/Analyses/index.tsx